import React, { ChangeEvent, useState } from 'react';

import { Button } from '@/components';
import { TextInput } from '@/components/text-input';
import { useTranslation } from 'react-i18next';
import { SignupDataType } from '@/utils/auth';
import { emailRegex } from '@/utils/validation';

import styles from '../Signup.module.css';

interface Step2Props {
  data: SignupDataType;
  inProgress: boolean;
  onChange: (data: SignupDataType) => void;
  onSubmit: () => void;
}

function Step2({ data, onChange, inProgress, onSubmit }: Step2Props) {
  const { t } = useTranslation();
  const [error, setError] = useState('');

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    onChange({ ...data, [name]: value });
    if (name === 'email' && error) setError('');
  };

  const handleSubmit = () => {
    if (!emailRegex.test(data.email)) {
      setError(t('alert.INVALID_EMAIL'));
      return;
    }
    onSubmit();
  };

  return (
    <div>
      <h3 className={styles.signupTitle}>{t('signup.step2.title')}</h3>
      <div className={styles.signupRow}>
        <TextInput
          label={t('signup.name')}
          value={data.first_name}
          placeholder={t('signup.name.placeholder')}
          onChange={handleChange}
          required
          name="first_name"
        />
      </div>
      <div className={styles.signupRow}>
        <TextInput
          label={t('signup.email')}
          value={data.email}
          placeholder={t('placeholder.emailExample')}
          onChange={handleChange}
          required
          name="email"
          error={error}
        />
      </div>
      <div className={styles.signupButtonWrap}>
        <Button
          disabled={!data.first_name.trim() || !data.email || inProgress || !!error}
          isLoading={inProgress}
          theme="cta"
          onClick={handleSubmit}
        >
          {t('signup.next')}
        </Button>
      </div>
    </div>
  );
}

export default Step2;
